import { Form, Button, Input } from 'antd';
import React from 'react';

type SpreadsheetUrlInputProps = {
  setSpreadsheetUrl: React.Dispatch<React.SetStateAction<string>>;
};

type SpreadsheetUrlFromValue = {
  spreadsheetUrl: string;
};

const SpreadsheetUrlInput: React.FC<SpreadsheetUrlInputProps> = ({ setSpreadsheetUrl }) => {
  const onSubmitSpreadsheetUrlForm = (values: SpreadsheetUrlFromValue) => {
    setSpreadsheetUrl(values.spreadsheetUrl);
  };

  return (
    <Form name="spreadsheetUrlForm" layout="inline" onFinish={onSubmitSpreadsheetUrlForm}>
      <Form.Item name="spreadsheetUrl" label="スプレッドシートの URL">
        <Input />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          取得
        </Button>
      </Form.Item>
    </Form>
  );
};

export default SpreadsheetUrlInput;
